import {Routes} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {SegmentacaoComponent} from './segmentacao/segmentacao.component';
import {ListasComponent} from './listas/listas/listas.component';
import {ContatosComponent} from './listas/contatos/contatos.component';
import {ListaUsuariosComponent} from './administrativo/usuarios/lista-usuarios/lista-usuarios.component';
import { SaldoGuard } from '../../guards/saldo.guard';
import { AuthGuard } from '../../guards/auth.guard';
import { EnumPermissao } from '../../enums/permissoes.enum';
import { MeusDadosComponent } from './administrativo/meus-dados/meus-dados.component';
export const areaLogadaRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'segmentacao',
    component: SegmentacaoComponent,
    canActivate: [SaldoGuard, AuthGuard],
    data: {
      requiredSaldo: true,
      permission: 2
    }
  },
  {
    path: 'listas',
    component: ListasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'contatos',
    component: ContatosComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'usuarios',
    component: ListaUsuariosComponent,
    canActivate: [AuthGuard],
    data: {
      permission: 7
    }
  },
  {
    path: 'meus-dados',
    component: MeusDadosComponent,
    canActivate: [AuthGuard]
  },
  // Rota curinga para páginas não encontradas
  {
    path: '**',
    redirectTo: 'home'
  }
];
